export default "__VITE_ASSET__BVqAobC3__"